import clsx from 'clsx';
import { Icon as LucideIcon } from 'lucide-react';
import { Icon } from '../Icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const iconNode = [['path', {
  d: 'M10.258 2.07C8.76 3.14 6.596 4.482 4.954 4.769c-1.224.222-2.071 1.369-2.071 2.62v4.222c0 9.5 9.147 10.88 9.147 10.88s9.148-1.328 9.148-10.88V7.388c0-1.251-.847-2.411-2.072-2.633-1.642-.287-3.792-1.642-5.29-2.697a3 3 0 0 0-3.558.012',
  key: '1tyl8d'
}], ['path', {
  d: 'm8.35 11.914 2.601 2.625 4.796-4.391',
  key: 'ntzdb1'
}]];
export function ProductCertificate({
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Icon, {
    icon: LucideIcon,
    iconNode: iconNode,
    className: clsx('lucide-custom-product-certificate', className),
    ...extraProps
  });
}